import { useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { checkEmailExists } from 'state/modules/email';
import { useSearchParams } from 'react-router';

const useReferralEmail = () => {
  const dispatch = useDispatch();
  const [searchParams] = useSearchParams();
  const checked = useSelector(state => state.email.checked);
  const checking = useSelector(state => state.email.checking);
  const exists = useSelector(state => state.email.exists);

  const email = searchParams.get('email');

  if (email && !checked && !checking) {
    const actionCheck = checkEmailExists(email);
    dispatch(actionCheck);
  }

  return useMemo(() => {
    if (!email) {
      return { checked: false, checking: false, exists: false };
    }
    // An email was set in the URL
    return { checked, checking, exists };
  }, [checked, checking, email, exists]);
};

export default useReferralEmail;
